import "./add.css"
import { Form, Input, Button, message, Select, Space } from "antd";
import { useNavigate } from 'react-router-dom';
import { COUNTRY_CODES, CountryService } from "../../services/Country";
import ReactCountryFlag from "react-country-flag";
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

function CountryAdd() {

    const navigate = useNavigate();
    const [form] = Form.useForm();

    const save = async (values: any) => {
        try {
            const { data } = await CountryService.create({ ...values });
            message.success('New Country added')
            navigate(`/`)
        } catch(error){
            console.log(error)
        }
    };


    return (
        <div className='wrapper'>
            <Form
                name="basic"
                form={form}
                onFinish={save}
                className='add-item'
                layout="vertical"
                initialValues={{ countryAdmin: [{name: '', email: ''}] }}
            >
                <h2>Add New Country</h2>

                <Form.Item
                    name="name"
                    label='Name'
                    rules={[{ required: true }]}
                >
                    <Select style={{width:'250px'}}>
                        {Object.entries(COUNTRY_CODES).map((name, code) => (
                            <Select.Option value={name[0]} key={code}>
                                <Space>
                                    <ReactCountryFlag countryCode={name[1]} svg />
                                    <span>{name[0]}</span>
                                </Space>
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                <div style={{paddingBottom: '8px'}}>Country Admins</div>
                <Form.List
                    name="countryAdmin"
                >
                    {(fields, { add, remove }, { errors }) => (
                        <>
                            {fields.map(({ key, name, ...restField }, index) => (
                                <Form.Item
                                    required={false}
                                    key={key}
                                >
                                        <Form.Item
                                            {...restField}
                                            name={[name, 'name']}
                                            validateTrigger={['onChange', 'onBlur']}
                                            rules={[
                                                {
                                                    required: true,
                                                    whitespace: true,
                                                    message: "Please input admin's name.",
                                                },
                                            ]}
                                            style= {{marginRight: 8, display:'flex'}}
                                            noStyle
                                        >
                                            <Input placeholder="Country Admin Name" style={{width:'250px'}}/>
                                        </Form.Item>
                                        <Form.Item
                                            {...restField}
                                            name={[name, 'email']}
                                            validateTrigger={['onChange', 'onBlur']}
                                            rules={[
                                                {
                                                    required: true,
                                                    whitespace: true,
                                                    message: "Please input admin's e-mail or delete this field.",
                                                },
                                            ]}
                                            noStyle
                                        >
                                            <Input placeholder="Country Admin E-mail" style={{width:'250px'}}/>
                                        </Form.Item>
                                        {fields.length > 1 ? (
                                            <MinusCircleOutlined
                                                style={{marginLeft:'16px'}}
                                                onClick={() => remove(name)}
                                            />

                                        ) : null}
                                  
                                </Form.Item>
                            ))}
                            <Form.Item>
                                <Button
                                    type="dashed"
                                    style={{width:'250px'}}
                                    onClick={() => add()}
                                    icon={<PlusOutlined />}
                                >
                                    Add Country Admin
                                </Button>
                                <Form.ErrorList errors={errors} />
                            </Form.Item>
                        </>
                    )}
                </Form.List>

                <Form.Item>
                    <Button type="primary" htmlType="submit" className="form-submit-button">
                        SAVE
                    </Button>
                </Form.Item>
            </Form>
        </div>

    );
}

export default CountryAdd;